import { apiAppVersion } from './apiAppVersion'
import { apiCache } from './apiCache'
import { apiOperationBlacklist } from './apiOperationBlacklist'
import { apiOperationSchedule } from './apiOperationSchedule'
import { apiOperationSchedulePublic } from './apiOperationSchedule.public'

const apiSystemGroup = {
	...apiAppVersion,
	...apiOperationSchedulePublic,
	...apiOperationSchedule,
	...apiOperationBlacklist,
	...apiCache,
}

export { apiSystemGroup }
